// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2yVml","sendOtp":"AuthorizeToLogin_sendOtp__3uDug"};